export const AUTH_BASE_PATH = "/api/auth";
export const DEVELOPMENT_AUTH_ORIGIN = "http://localhost:3000";

export function resolveAuthOrigin(value?: string) {
  const candidate = value?.trim() || DEVELOPMENT_AUTH_ORIGIN;

  let url: URL;
  try {
    url = new URL(candidate);
  } catch {
    throw new Error(
      "BETTER_AUTH_URL must be an absolute HTTP(S) URL, such as https://admin.example.com.",
    );
  }

  if (
    (url.protocol !== "http:" && url.protocol !== "https:") ||
    url.username ||
    url.password
  ) {
    throw new Error(
      "BETTER_AUTH_URL must be an HTTP(S) origin without embedded credentials.",
    );
  }

  // Better Auth treats a path in baseURL as the API mount path. Reducing the
  // owner-supplied value to its origin prevents a callback URL pasted into
  // Render from silently remounting the API and turning valid routes into 404s.
  return url.origin;
}
